export default __webpack_public_path__ + "static/safari-a202cd01d2b42a4b7ad6273eb6a3ddd3.svg";